export enum SigFoxMessageType {
  TestMessage = 0x04,
  SNTS = 0x05, // SNTS = sequence number and timestamp
  SCHD = 0x06, // SCHD = scheduled reading
  DeviceConfig1 = 0x07,
  DeviceConfig2 = 0x08,
  DeviceConfig3 = 0x09,
  DeviceConfig4 = 0x0a,
  DeviceConfig5 = 0x0b,
  SensorConfig1 = 0x0c,
  Unknown = 0xff,
}
